<script>
  import CountryPicker from '../CountryPicker/CountryPicker.svelte';

  export let data,
    color = '',
    isLoggedIn = false,
    testId;

  $: footerData = data ? data : null;
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  a {
    color: inherit;
    text-decoration: none;
  }

  .business-info {
    padding-block-start: spacing(3);
  }

  .for-logged-in {
    display: none;
  }

  .footer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: spacing(2);
    grid-column-gap: spacing(1);
    padding: spacing(6) spacing(3);

    &.is-logged-in {
      .for-logged-in {
        display: block;
      }

      .for-logged-out {
        display: none;
      }
    }

    &.white {
      background-color: $white;
    }
  }

  .footer-column {
    grid-column: span 2;
  }

  .column-name {
    display: inline-block;
    color: $grey-60;
    font-size: 11px;
    font-weight: 500;
    height: 16px;
    letter-spacing: 1.2px;
    line-height: 16px;
    margin-block-end: 24px;
    overflow-wrap: break-word;
    text-transform: uppercase;
    word-break: keep-all;
  }

  .footer-list {
    color: $black;
    display: block;
    font-size: 1.6rem;
    font-stretch: 100%;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: spacing(3);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .footer-list-item {
    margin-block-end: spacing(3);
  }

  .footer-link {
    font-weight: inherit;

    &:hover {
      color: $orange-50;
    }
  }

  :global(.logged-in .footer-country-picker) {
    display: none;
  }

  @include mq($from: tabletportrait) {
    .footer {
      grid-column-gap: spacing(2);
      grid-row-gap: 4.2rem;
      grid-template-columns: repeat(12, 1fr);
      padding: 6.4rem 3.2rem;
    }

    .footer-column {
      grid-column: span 6;
    }
  }

  @include mq($from: tabletlandscape) {
    .footer {
      grid-column-gap: spacing(3);
      padding: 8rem;
    }
  }

  @include mq($from: desktop) {
    .footer {
      grid-column-gap: 3.2rem;
      grid-template-columns: repeat(12, 6.4rem);
      padding: 8rem calc((100vw - 112rem) / 2);
    }

    .footer-column {
      grid-column: span 3;
    }
  }

  @include mq($from: wide) {
    .footer {
      grid-template-columns: repeat(12, 8.8rem);
      padding: 8rem calc((100vw - 140.8rem) / 2);
    }
  }
</style>

<footer
  id="footerComponent"
  class={`footer ${color}`}
  class:is-logged-in={isLoggedIn}
  data-testid={testId}
>
  {#if footerData}
    {#each footerData.columns as column, index}
      <div class="footer-column">
        <span class="column-name" data-testid="bottom-navigation-item-{index}">{column.name}</span>
        <ul class="footer-list">
          {#each column.items as item, i}
            <li
              class="footer-list-item"
              class:for-logged-in={item.showForLoggedIn === true}
              class:for-logged-out={item.showForLoggedOut === true}
              data-testid="bottom-navigation-subitem-{index}-{i}"
            >
              <a href={item.url} rel="external" class="footer-link">{item.name}</a>
            </li>
          {/each}
        </ul>
      </div>
    {/each}
    <div class="footer-column">
      {#if !isLoggedIn && !footerData.hideCountryPicker}
        <div class="footer-country-picker">
          <span class="column-name">{footerData.chooseCountryLabel}</span>
          <CountryPicker selected={footerData.selectedCountry} />
        </div>
      {/if}
      {#if footerData.businessInfo}
        <div class="business-info">
          {@html footerData.businessInfo}
        </div>
      {/if}
    </div>
  {/if}
</footer>
